import React, { useState, useEffect } from 'react';
import { FaPhoneSlash, FaTrash, FaPlus, FaSearch, FaSync, FaUserTimes, FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import axiosInstance from '../utils/axiosInstance';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';

const CallMeBlacklist = () => {
  const [list,        setList]        = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [searchTerm,  setSearchTerm]  = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData,    setFormData]    = useState({ username:'', reason:'' });

  const fetchData = async () => {
    setLoading(true);
    try { const r = await axiosInstance.get('/callmeblacklist/all'); setList(r.data); }
    catch { toast.error('Liste yüklenemedi!'); }
    finally { setLoading(false); }
  };
  useEffect(() => { fetchData(); }, []);

  const openModal = () => { setFormData({ username:'', reason:'' }); setIsModalOpen(true); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try { await axiosInstance.post('/callmeblacklist/save', formData); toast.success('Kullanıcı engellendi.'); setIsModalOpen(false); fetchData(); }
    catch (e) { toast.error(e.response?.data?.message || 'Hata oluştu!'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Arama engelini kaldırmak istediğinize emin misiniz?')) return;
    try { await axiosInstance.delete(`/callmeblacklist/${id}`); toast.success('Engel kaldırıldı.'); fetchData(); }
    catch { toast.error('Silme başarısız.'); }
  };

  const filtered = list.filter(i => i.username.toLowerCase().includes(searchTerm.toLowerCase()));
  const inp = { width:'100%', padding:'10px 13px', background:'#0d0e12', border:'1px solid rgba(255,255,255,.08)', borderRadius:10, color:'#f1f5f9', fontSize:'.83rem', fontFamily:"'Outfit',sans-serif", outline:'none', transition:'all .2s' };
  const lbl = { display:'block', fontSize:'.63rem', fontWeight:600, textTransform:'uppercase', letterSpacing:'1px', color:'rgba(255,255,255,.26)', marginBottom:6 };

  return (
    <div style={{ minHeight:'100vh', background:'#090a0c', padding:'28px 28px 40px', color:'#e2e8f0', fontFamily:"'Outfit','Inter',sans-serif", boxSizing:'border-box' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');
        *{box-sizing:border-box}
        .cm-row:hover{background:rgba(255,255,255,.03)!important;transform:translateX(2px)}
        .cm-btn:hover{filter:brightness(1.2);transform:scale(1.07)}
        .cm-inp:focus{border-color:#f27127!important;box-shadow:0 0 0 3px rgba(242,113,39,.1)!important}
        @keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}
        .cm-fade{animation:fadeUp .3s ease both}
      `}</style>

      {/* Header */}
      <div className="cm-fade" style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24 }}>
        <div style={{ display:'flex', alignItems:'center', gap:14 }}>
          <div style={{ width:44, height:44, borderRadius:13, background:'rgba(234,179,8,.1)', border:'1px solid rgba(234,179,8,.25)', display:'flex', alignItems:'center', justifyContent:'center', color:'#eab308', fontSize:'1.1rem', boxShadow:'0 0 18px rgba(234,179,8,.1)' }}><FaPhoneSlash /></div>
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <h2 style={{ margin:0, fontSize:'1.2rem', fontWeight:700, color:'#f8fafc', letterSpacing:'-.3px' }}>Beni Ara Blacklist</h2>
              <span style={{ padding:'2px 10px', borderRadius:20, background:'rgba(234,179,8,.1)', color:'#eab308', border:'1px solid rgba(234,179,8,.2)', fontSize:'.7rem', fontWeight:700 }}>{list.length}</span>
            </div>
            <p style={{ margin:'3px 0 0', fontSize:'.71rem', color:'rgba(255,255,255,.22)' }}>Bu listedeki kullanıcılar "Beni Ara" talebi oluşturamazlar</p>
          </div>
        </div>
        <div style={{ display:'flex', gap:9 }}>
          <button onClick={fetchData} style={{ display:'flex', alignItems:'center', gap:7, padding:'9px 14px', borderRadius:10, border:'1px solid rgba(255,255,255,.08)', background:'rgba(255,255,255,.04)', color:'rgba(255,255,255,.45)', fontSize:'.79rem', fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}>
            <FaSync style={{ fontSize:'.7rem', animation:loading?'spin 1s linear infinite':'none' }} /> Yenile
          </button>
          <button onClick={openModal} style={{ display:'flex', alignItems:'center', gap:7, padding:'9px 16px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#eab308,#ca8a04)', color:'#fff', fontSize:'.79rem', fontWeight:700, cursor:'pointer', fontFamily:'inherit', boxShadow:'0 4px 14px rgba(234,179,8,.25)' }}>
            <FaPhoneSlash style={{ fontSize:'.75rem' }} /> Kullanıcı Engelle
          </button>
        </div>
      </div>

      {/* Arama */}
      <div style={{ position:'relative', marginBottom:18 }}>
        <FaSearch style={{ position:'absolute', left:14, top:'50%', transform:'translateY(-50%)', color:'rgba(255,255,255,.25)', fontSize:'.85rem', pointerEvents:'none' }} />
        <input className="cm-inp" type="text" placeholder="Engelli kullanıcı ara..." value={searchTerm} onChange={e=>setSearchTerm(e.target.value)}
          style={{ ...inp, paddingLeft:40, background:'#111318', border:'1px solid rgba(255,255,255,.07)' }} />
      </div>

      {/* Tablo */}
      <div style={{ background:'#111318', border:'1px solid rgba(255,255,255,.06)', borderRadius:20, overflow:'hidden' }}>
        <div style={{ display:'grid', gridTemplateColumns:'180px 1fr 160px 60px', padding:'12px 18px', borderBottom:'1px solid rgba(255,255,255,.05)', background:'rgba(0,0,0,.2)' }}>
          {['KULLANICI','ENGEL NEDENİ','TARİH',''].map((h,i) => (
            <div key={i} style={{ fontSize:'.59rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'1.2px', color:'rgba(255,255,255,.2)', textAlign:i===3?'center':'left' }}>{h}</div>
          ))}
        </div>
        <div style={{ padding:'6px 8px' }}>
          {loading ? Array.from({length:4}).map((_,i) => <div key={i} style={{ height:48, borderRadius:12, marginBottom:4, background:'rgba(255,255,255,.03)' }} />)
          : filtered.length > 0 ? filtered.map(item => (
            <div key={item._id} className="cm-row" style={{ display:'grid', gridTemplateColumns:'180px 1fr 160px 60px', alignItems:'center', padding:'11px 10px', borderRadius:12, marginBottom:4, background:'rgba(255,255,255,.015)', border:'1px solid rgba(255,255,255,.03)', position:'relative', overflow:'hidden', transition:'all .15s' }}>
              <div style={{ position:'absolute', left:0, top:'15%', bottom:'15%', width:3, borderRadius:'0 3px 3px 0', background:'#eab308', boxShadow:'0 0 8px rgba(234,179,8,.5)' }} />
              <div style={{ paddingLeft:8, display:'flex', alignItems:'center', gap:8 }}>
                <div style={{ width:26, height:26, borderRadius:7, background:'rgba(234,179,8,.1)', border:'1px solid rgba(234,179,8,.18)', display:'flex', alignItems:'center', justifyContent:'center', color:'#eab308', fontSize:'.65rem', flexShrink:0 }}><FaUserTimes /></div>
                <span style={{ fontSize:'.83rem', fontWeight:700, color:'#f1f5f9' }}>{item.username}</span>
              </div>
              <div>
                {item.reason
                  ? <span style={{ fontSize:'.78rem', color:'#94a3b8' }}>{item.reason.length>60?item.reason.slice(0,60)+'…':item.reason}</span>
                  : <span style={{ fontSize:'.75rem', color:'rgba(255,255,255,.15)' }}>Kural ihlali</span>}
              </div>
              <div style={{ fontSize:'.74rem', color:'rgba(255,255,255,.3)' }}>{dayjs(item.createdAt).format('DD/MM/YY HH:mm')}</div>
              <div style={{ display:'flex', justifyContent:'center' }}>
                <button className="cm-btn" onClick={() => handleDelete(item._id)} style={{ width:30, height:30, borderRadius:8, border:'none', cursor:'pointer', background:'rgba(239,68,68,.12)', color:'#f87171', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.75rem', transition:'all .15s' }}><FaTrash /></button>
              </div>
            </div>
          )) : (
            <div style={{ textAlign:'center', padding:'50px 0', color:'rgba(255,255,255,.15)', fontSize:'.85rem' }}>
              <FaPhoneSlash style={{ fontSize:'2rem', opacity:.15, display:'block', margin:'0 auto 10px' }} />Engellenmiş kullanıcı bulunamadı
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div onClick={() => setIsModalOpen(false)} style={{ position:'fixed', inset:0, zIndex:10000, background:'rgba(0,0,0,.8)', backdropFilter:'blur(10px)', display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
          <div onClick={e=>e.stopPropagation()} style={{ width:'100%', maxWidth:460, background:'#111318', border:'1px solid rgba(234,179,8,.18)', borderRadius:22, overflow:'hidden', boxShadow:'0 32px 80px rgba(0,0,0,.7)' }}>
            <div style={{ padding:'20px 24px 16px', borderBottom:'1px solid rgba(255,255,255,.05)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                <div style={{ width:38, height:38, borderRadius:10, background:'rgba(234,179,8,.12)', border:'1px solid rgba(234,179,8,.25)', display:'flex', alignItems:'center', justifyContent:'center', color:'#eab308' }}><FaExclamationTriangle /></div>
                <div>
                  <div style={{ fontWeight:700, fontSize:'.92rem', color:'#f8fafc' }}>Yeni Arama Engeli</div>
                  <div style={{ fontSize:'.68rem', color:'rgba(255,255,255,.25)', marginTop:2 }}>Kullanıcının arama talebini engelleyin</div>
                </div>
              </div>
              <button onClick={() => setIsModalOpen(false)} style={{ width:30, height:30, borderRadius:8, border:'none', cursor:'pointer', background:'rgba(255,255,255,.06)', color:'rgba(255,255,255,.35)', display:'flex', alignItems:'center', justifyContent:'center' }}><FaTimes /></button>
            </div>
            <form onSubmit={handleSubmit} style={{ padding:'20px 24px 24px' }}>
              <div style={{ marginBottom:14 }}>
                <label style={lbl}>Kullanıcı Adı</label>
                <input className="cm-inp" value={formData.username} onChange={e=>setFormData({...formData,username:e.target.value})} placeholder="Engellenecek kullanıcı adı..." required style={inp} />
              </div>
              <div style={{ marginBottom:22 }}>
                <label style={lbl}>Engel Nedeni</label>
                <textarea className="cm-inp" rows={3} value={formData.reason} onChange={e=>setFormData({...formData,reason:e.target.value})} placeholder="Neden kısıtlanıyor?" style={{ ...inp, resize:'none', lineHeight:1.55 }} />
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                <button type="button" onClick={() => setIsModalOpen(false)} style={{ padding:'11px', borderRadius:11, border:'1px solid rgba(255,255,255,.08)', background:'rgba(255,255,255,.05)', color:'rgba(255,255,255,.5)', fontSize:'.82rem', fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}>İptal</button>
                <button type="submit" style={{ padding:'11px', borderRadius:11, border:'none', background:'linear-gradient(135deg,#eab308,#ca8a04)', color:'#fff', fontSize:'.82rem', fontWeight:700, cursor:'pointer', fontFamily:'inherit', boxShadow:'0 4px 14px rgba(234,179,8,.22)' }}>Engeli Onayla</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};
export default CallMeBlacklist;
